import React from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";

export function CopyId({ value, testId }) {
  if (!value) return <span style={{ color: "var(--muted)" }}>—</span>;
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); toast.success("Copied"); }
    catch { toast.error("Could not copy. Select the ID and copy it manually."); }
  };
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="font-mono text-xs" style={{ color: "var(--ink)" }} data-testid={`${testId}-value`}>{value}</span>
      <button type="button" onClick={copy} className="p-1 opacity-60 hover:opacity-100 transition-opacity"
              aria-label={`Copy Company ID ${value}`} title="Copy Company ID" data-testid={`${testId}-copy`}>
        <Copy size={12} />
      </button>
    </span>
  );
}
